import React from 'react'

// Deep-link params the app uses to hand a question to an ask surface — set by
// the in-app help popover, the Slack bot, the desktop shell and onboarding.
const FILL_PARAM = 'fillAskQuestion'
const SUBMIT_PARAM = 'submitAskQuestion'

type Params = {
  setQuestion: (question: string) => void
  ask: (question: string) => void
}

// Reads `window.location` rather than vike's pageContext: the server entry
// hands vike a search-less URL, so `urlParsed.search` is always empty.
export function useAskQuestionFromUrl({ setQuestion, ask }: Params) {
  // Only the landing URL seeds the widget, which outlives client-side
  // navigations — and StrictMode double-invokes effects in dev.
  const hasSeeded = React.useRef(false)

  // biome-ignore lint/correctness/useExhaustiveDependencies: reads the landing URL once on mount
  React.useEffect(() => {
    if (hasSeeded.current) {
      return
    }
    hasSeeded.current = true

    const url = new URL(window.location.href)
    const question = url.searchParams.get(FILL_PARAM)
    if (!question) {
      return
    }
    const shouldSubmit = url.searchParams.get(SUBMIT_PARAM) === 'true'

    url.searchParams.delete(FILL_PARAM)
    url.searchParams.delete(SUBMIT_PARAM)
    window.history.replaceState(window.history.state, '', url)

    if (shouldSubmit) {
      ask(question)
    } else {
      setQuestion(question)
    }
  }, [])
}
